/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-useless-escape */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter, Link } from 'react-router-dom';

import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
// import NumberFormat from 'react-number-format';
// import Email from 'react-email-autocomplete';

import JoinStep1 from '../containers/join/JoinStepOne';
import JoinStep2 from '../containers/join/JoinStepTwo';
import JoinStep3 from '../containers/join/JoinStepTree';

// import moment from 'moment'

class Join extends Component {
  state = {
    userid: '',
    username: '',
    nicName: '',
    password: '',
    password_re: '',
    mobile: '',
    email: '',
    aAgree: false,
    mAgree: false,
    sAgree: false,
    age14: false,
    parentAgree: 0,

    isDupUsreid: false,
    isDupNicname: false,

    dupButtonState: 'A',
    dupButtonNicnameSate: 'A',

    birthDay: '', //생년월일
    ci: '',
    di: '',
    gender: '', //성별
    //mobile: phoneNo,
    nation: '', //외국인

    snsid: '',
    snsGubun: 'A', //SNS 구분 A: 애니플러스 T, N, K, G, F,
    snsJoin: false, //SNS 회원가입 여부

    cert: false, //본인(실명)인증 여부
    certGubun: '',
    joinStep: 1, //회원가입 단계
  };
  _isMounted = false;

  _chkAge14 = (birthday) => {
    console.log('chkAge14');

    let rightNow = new Date();
    console.log(birthday, rightNow);

    let age = rightNow.getFullYear() - birthday.getFullYear();

    let birthMonth = birthday.getMonth();
    let thisMonth = rightNow.getMonth();

    let birthDate = birthday.getDate();
    let thisDate = rightNow.getDate();

    if (birthMonth < thisMonth) {
      return age;
    } else if (birthMonth >= thisMonth) {
      return age - 1;
    } else {
      if (birthDate < thisDate) {
        return age;
      } else {
        return age - 1;
      }
    }
  };

  componentDidMount = () => {
    this._isMounted = true;
    const { loginId, history } = this.props;

    //const test = 19730620

    //console.log(parseInt(test.toString().substr(0, 4)))
    //console.log(parseInt(test.toString().substr(4, 2)))
    //console.log(parseInt(test.toString().substr(6, 2)))
    //console.log(this._chkAge14(new Date(1973, 6, 20)))
    // console.log(this._chkAge14(new Date(2009, 10, 21)));
    // const a = '14';
    // if (parseInt(a) < 14) {
    //   console.log('작다');
    // } else {
    //   console.log('작지 않다');
    // }

    if (loginId !== '' && loginId !== null && loginId !== undefined) {
      history.push('/');
    }

    const ran = Math.random();
    const backNumber = Math.floor(ran * 3);
    if (this._isMounted) {
      this.setState({
        backNumber,
      });
    }

    window.addEventListener('message', this.callbackCert);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener('message', this.callbackCert);
  };
  callbackCert = async (e) => {
    //console.log(e)
    const { age14, parentAgree } = this.state;
    const { history } = this.props;
    if (e.data[0] === undefined || e.data[0] === null || e.data[0] === '') {
    } else {
      const callbackPart = e.data[0].callbackPart;
      const intReturn = e.data[0].intReturn;
      ////console.log(callbackPart)
      ////console.log(intReturn)
      if (callbackPart === 'SNS') {
        if (intReturn === '0') {
          toast.warn('해당 SNS계정으로 가입이 되어있습니다.');
        } else if (intReturn === '-1') {
          const snsid = e.data[0].snsid;
          const snsUsername = e.data[0].username;
          const snsEmail = e.data[0].email;
          //const snsPhoto = e.data[0].photo;
          const snsGubun = e.data[0].gubun;

          //console.log(snsid, snsEmail, snsGubun)
          setTimeout(() => {
            //alert(0)
            this.setState({
              //userid: 'aaaaaaaaaaa',
              snsid: snsid,
              email: snsEmail,
              username: snsUsername,
              snsGubun: snsGubun,
              snsJoin: true,
            });
          }, 500);
        } else {
          toast.error('SNS 계정 정보를 전달 중 오류가 발생했습니다.');
        }
      } else if (callbackPart === 'CERTPHONE') {
        //본인인증
        console.log(e.data);

        let birthDay = e.data[0].birthDay; //730620

        const ci = e.data[0].ci;
        const di = e.data[0].di;
        const gender = e.data[0].gender;

        if (birthDay.length <= 6) {
          if (gender < 3) {
            birthDay = '19' + birthDay.toString();
          } else {
            birthDay = '20' + birthDay.toString();
          }
        }

        const yy = parseInt(birthDay.toString().substr(0, 4));
        const mm = parseInt(birthDay.toString().substr(4, 2));
        const dd = parseInt(birthDay.toString().substr(6, 2));

        const returnAge = this._chkAge14(new Date(yy, mm, dd));

        console.log(parseInt(birthDay.toString().substr(0, 4)));
        console.log(parseInt(birthDay.toString().substr(4, 2)));
        console.log(parseInt(birthDay.toString().substr(6, 2)));
        console.log(returnAge);

        //console.log(this._chkAge14(new Date(1973, 6, 20)))
        //console.log(age14)
        //console.log(birthDay)

        //const intReturn = e.data[0].intReturn;
        const name = e.data[0].name;
        // const phoneNo = e.data[0].phoneNo;
        const nation = e.data[0].nation; // 0 한국인
        const reqNum = e.data[0].reqNum;
        //해당 di로 가입 여부 확인후 처리할것.
        const result = await this._onRealNameCheckApi(di);
        const intReturn = result.data[0].intReturn;

        if (age14) {
          if (parseInt(returnAge) < 14) {
            toast.error('만 14세 미만은 가입이 불가합니다.');
          } else {
            if (intReturn === 0) {
              this.setState({
                username: name,
                birthDay: birthDay,
                ci: ci,
                di: di,
                gender: gender,
                //mobile: phoneNo,
                cert: true,
                nation: nation,
                certGubun: 'A',
                reqNum: reqNum,
              });

              setTimeout(() => {
                this._onJoin();
              }, 500);
            } else {
              //이미 가입되어 있음
              confirmAlert({
                title: '중복가입',
                message:
                  '조회하신 실명으로 이미 회원가입이 되어있습니다. 아이디 및 비밀번호를 찾으시겠습니까?',
                buttons: [
                  {
                    label: '예',
                    onClick: () => {
                      history.push('/find');
                    },
                  },
                  {
                    label: '로그인',
                    onClick: () => {
                      history.push('/login');
                    },
                  },
                  {
                    label: '나가기',
                    onClick: () => {
                      history.push('/');
                    },
                  },
                ],
              });
            }
          }
        } else {
          if (parseInt(returnAge) >= 14) {
            toast.error('14세 이상이므로 일반 가입으로 재시도 해주세요.');
            return;
          }

          if (parseInt(parentAgree) >= parseInt(returnAge) + 19) {
            //14세미만 가입절차.
            if (intReturn === 0) {
              this.setState({
                username: name,
                birthDay: birthDay,
                ci: ci,
                di: di,
                gender: gender,
                //mobile: phoneNo,
                cert: true,
                nation: nation,
                certGubun: 'A',
                reqNum: reqNum,
              });

              setTimeout(() => {
                this._onJoin();
              }, 500);
            } else {
              //이미 가입되어 있음
              confirmAlert({
                title: '중복가입',
                message:
                  '조회하신 실명으로 이미 회원가입이 되어있습니다. 아이디 및 비밀번호를 찾으시겠습니까?',
                buttons: [
                  {
                    label: '예',
                    onClick: () => {
                      history.push('/find');
                    },
                  },
                  {
                    label: '로그인',
                    onClick: () => {
                      history.push('/login');
                    },
                  },
                  {
                    label: '나가기',
                    onClick: () => {
                      history.push('/');
                    },
                  },
                ],
              });
            }
          } else {
            //가입불가
            toast.error(
              '14세 미만 미성년자의 회원가입을 위해서는 가입자와 나이차이가 19세 이상인 법정대리인(보호자)의 동의가 필요합니다.'
            );
          }
        }
      } else if (callbackPart === 'CERTIPIN') {
        const birthDay = e.data[0].birthdate; //19730620
        const ci = e.data[0].coinfo1;
        const di = e.data[0].dupinfo;
        const gender = e.data[0].sex;
        //const intReturn = e.data[0].intReturn;
        const name = e.data[0].realname;
        // const phoneNo = '';
        const nation = e.data[0].nationalinfo; // 0 한국인
        const reqNum = e.data[0].cprequestnumber;

        const result = await this._onRealNameCheckApi(di);
        const intReturn = result.data[0].intReturn;

        const yy = parseInt(birthDay.toString().substr(0, 4));
        const mm = parseInt(birthDay.toString().substr(4, 2));
        const dd = parseInt(birthDay.toString().substr(6, 2));

        const returnAge = this._chkAge14(new Date(yy, mm, dd));

        if (age14) {
          if (parseInt(returnAge) < 14) {
            toast.error('만 14세 미만은 가입이 불가합니다.');
          } else {
            if (intReturn === 0) {
              this.setState({
                username: name,
                birthDay: birthDay,
                ci: ci,
                di: di,
                gender: gender,
                //mobile: phoneNo,
                cert: true,
                nation: nation,
                certGubun: 'I',
                reqNum: reqNum,
              });

              setTimeout(() => {
                this._onJoin();
              }, 500);
            } else {
              //이미 가입되어 있음
              confirmAlert({
                title: '본인인증',
                message:
                  '본의 명의로 이미 가입되어 있는 회원정보가 존재합니다.',
                buttons: [
                  {
                    label: '아아디/패스워드 찾기',
                    onClick: () => {
                      history.push('/find');
                    },
                  },
                  {
                    label: '로그인',
                    onClick: () => {
                      history.push('/login');
                    },
                  },
                  {
                    label: '닫기',
                    //onClick: () => alert('Click No')
                  },
                ],
              });
            }
          }
        } else {
          if (parseInt(returnAge) >= 14) {
            toast.error('14세 이상이므로 일반 가입으로 재시도 해주세요.');
            return;
          }

          if (parseInt(parentAgree) >= parseInt(returnAge) + 19) {
            if (intReturn === 0) {
              this.setState({
                username: name,
                birthDay: birthDay,
                ci: ci,
                di: di,
                gender: gender,
                //mobile: phoneNo,
                cert: true,
                nation: nation,
                certGubun: 'I',
                reqNum: reqNum,
              });

              setTimeout(() => {
                this._onJoin();
              }, 500);
            } else {
              //이미 가입되어 있음
              confirmAlert({
                title: '본인인증',
                message:
                  '본의 명의로 이미 가입되어 있는 회원정보가 존재합니다.',
                buttons: [
                  {
                    label: '아아디/패스워드 찾기',
                    onClick: () => {
                      history.push('/find');
                    },
                  },
                  {
                    label: '로그인',
                    onClick: () => {
                      history.push('/login');
                    },
                  },
                  {
                    label: '닫기',
                    //onClick: () => alert('Click No')
                  },
                ],
              });
            }
          } else {
            //가입불가
            toast.error(
              '14세 미만 미성년자의 회원가입을 위해서는 가입자와 나이차이가 19세 이상인 법정대리인(보호자)의 동의가 필요합니다.'
            );
          }
        }
      } else if (callbackPart === 'PARENT') {
        let birthDay = e.data[0].birthDay; //730620
        const ci = e.data[0].ci;
        const di = e.data[0].di;
        const gender = e.data[0].gender;

        if (birthDay.length <= 6) {
          if (gender < 3) {
            birthDay = '19' + birthDay.toString();
          } else {
            birthDay = '20' + birthDay.toString();
          }
        }

        const yy = parseInt(birthDay.toString().substr(0, 4));
        const mm = parseInt(birthDay.toString().substr(4, 2));
        const dd = parseInt(birthDay.toString().substr(6, 2));

        const returnAge = this._chkAge14(new Date(yy, mm, dd));
        const name = e.data[0].name;
        const phoneNo = e.data[0].phoneNo;
        // const nation = e.data[0].nation;      // 0 한국인
        // const reqNum = e.data[0].reqNum;

        if (
          returnAge === null ||
          returnAge === undefined ||
          returnAge === '' ||
          returnAge === 0
        ) {
          toast.error('법정 보호자 동의 중 오류가 발생했습니다.');
        } else {
          //console.log(returnAge)
          this.setState({
            parentAgree: returnAge,
            parentName: name,
            parentPhone: phoneNo,
            parentDi: di,
            parentCi: ci,
          });
          toast.success(
            '법정 보호자의 동의가 완료되었습니다. [계속하기]를 눌러 진행해 주세요'
          );
        }
      }
    }
  };
  _onJoin = async () => {
    const { userid, username, password, password_re, di } = this.state;

    if (userid === '' || userid === null || userid === undefined) {
      toast.error('아이디가 누락되었습니다.');
      return;
    }
    if (username === '' || username === null || username === undefined) {
      toast.error('이름이 누락되었습니다.');
      return;
    }
    if (password === '' || password === null || password === undefined) {
      toast.error('비밀번호가 누락되었습니다.');
      return;
    }
    if (password !== password_re) {
      toast.error('비밀번호가 일치하지 않습니다.');
      return;
    }
    if (di === '' || di === null || di === undefined) {
      toast.error('실명인증이 누락되었습니다.');
      return;
    }

    const result = await this._onJoinApi();
    const intReturn = result.data[0].intReturn;
    //console.log('====================>>>>')
    //console.log(intReturn)
    if (intReturn === 0) {
      this.setState({
        joinStep: 3,
      });
    } else if (intReturn === -5) {
      toast.error('이미 가입되어 있는 DI 정보입니다.');
    } else if (intReturn === -1) {
      toast.error('중복된 아이디입니다.');
    } else if (intReturn === -6) {
      toast.error('중복된 닉네임입니다.');
    }
  };
  _onJoinApi = () => {
    const { apiUrl } = this.props;
    const {
      userid,
      username,
      nicName,
      password,
      mobile,
      email,
      birthDay,
      ci,
      di,
      gender,
      nation,
      snsid,
      snsGubun,
      snsJoin,
      cert,
      certGubun,
      reqNum,
      age14,
      parentAgree,
      parentName,
      parentPhone,
      parentDi,
      parentCi,
    } = this.state;

    return axios
      .post(apiUrl + '/joinMemberNew', {
        params: {
          userid: userid,
          username: username,
          nicName: nicName,
          password: password,
          mobile: mobile,
          email: email,
          birthDay: birthDay,
          ci: ci,
          di: di,
          gender: gender,
          nation: nation,
          snsid: snsid,
          snsGubun: snsGubun,
          snsJoin: snsJoin,
          cert: cert,
          certGubun: certGubun,
          reqNum: reqNum,
          memberPartCode: 0, //1:web 10: mobile
          age14: age14,
          parentAgree: parentAgree,
          parentName: parentName,
          parentPhone: parentPhone,
          parentDi: parentDi,
          parentCi: parentCi,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };

  _onRealNameCheckApi = (di) => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + '/realNameCheck', {
        params: {
          di: di,
        },
      })

      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _onMobile = () => {
    const popupUrl =
      'https://www.aniplustv.com/aniplus2020Api/Join/join_2nd_1.asp';
    window.open(
      popupUrl,
      'certWindow',
      'width=450, height=600, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250'
    );
  };
  _onIpin = () => {
    const popupUrl =
      'https://www.aniplustv.com/aniplus2020Api/Join/join_2nd_ipin_1.asp';
    window.open(
      popupUrl,
      'certWindow',
      'width=450, height=600, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250'
    );
  };
  _onChange = (e) => {
    ////console.log(e.target.name)
    //console.log(e.target.value.toLowerCase())
    //const text = e.target.value.toLowerCase()
    this.setState({
      [e.target.name]: e.target.value.toLowerCase(),
    });
  };
  /*
    _chkValue = (e) => {
        ////console.log(e.target.checked)
        //const { chkValue } = this.state
        this.setState({
            [e.target.name]: e.target.checked 
        })

       
    }
    */
  _dupUserid = async () => {
    const { userid, dupButtonState } = this.state;
    let confirm = 'Y';
    const s_pattern = /[~!@\#$%^&*\()\-=+_'\;<>\/.\`:\"\\,\[\]?|{}]/gi;
    const k_pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/gi;
    if (dupButtonState === 'C') {
      this.setState({
        userid: '',
        isDupUsreid: false,
        dupButtonState: 'A',
      });
    } else {
      if (userid === null || userid === undefined || userid === '') {
        toast.warn('중복 체크할 아이디를 입력해 주세요.');
        confirm = 'N';
        return;
      }
      if (userid.search(/\s/) !== -1) {
        toast.warn('아이디에 공백문자는 포함될 수 없습니다.');
        confirm = 'N';
        return;
      }
      if (Number(userid)) {
        toast.warn('아이디는 숫자만 사용할 수 없습니다.');
        return;
        //alert("아이디는 숫자만 사용할 수 없습니다.");
      }
      if (!/^[a-zA-Z]/.test(userid)) {
        toast.warn('아이디는 영문으로 시작해야 합니다.');
        return;
        //alert("아이디는 영문으로 시작해야 합니다.");
      }
      if (s_pattern.test(userid) === true) {
        toast.warn(
          '아이디에 [`~!@#$%^&*|\\\'";:/?등 의 특수문자는 포함될 수 없습니다.'
        );
        confirm = 'N';
        return;
      }
      if (k_pattern.test(userid) === true) {
        toast.warn('아이디에 한글은 포함될 수 없습니다.');
        confirm = 'N';
        return;
      }

      if (confirm === 'Y') {
        const result = await this._dupUseridApi();
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          toast.success('중복확인! 사용가능한 ID입니다.');
        } else {
          toast.error('이미 사용중인 아이디입니다.');
        }
        this.setState({
          isDupUsreid: intReturn === 0 ? true : false,
          dupButtonState: intReturn === 0 ? 'C' : 'B',
        });
      }
    }
  };
  _dupNicname = async () => {
    const { nicName, dupButtonNicnameSate } = this.state;
    let confirm = 'Y';
    const s_pattern = /[~!@\#$%^&*\()\-=+_'\;<>\/.\`:\"\\,\[\]?|{}]/gi;
    // const k_pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/gi;

    //console.log(dupButtonNicnameSate)
    if (dupButtonNicnameSate === 'C') {
      this.setState({
        nicName: '',
        isDupNicname: false,
        dupButtonNicnameSate: 'A',
      });
    } else {
      if (nicName === null || nicName === undefined || nicName === '') {
        toast.warn('중복 체크할 니네임을 입력해 주세요.');
        confirm = 'N';
        return;
      }
      if (nicName.search(/\s/) !== -1) {
        toast.warn('닉네임에 공백문자는 포함될 수 없습니다.');
        confirm = 'N';
        return;
      }
      if (s_pattern.test(nicName) === true) {
        toast.warn(
          '닉네임에 [`~!@#$%^&*|\\\'";:/?등 의 특수문자는 포함될 수 없습니다.'
        );
        confirm = 'N';
        return;
      }

      if (confirm === 'Y') {
        const result = await this._dupNicnameApi();
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          toast.success('중복확인! 사용가능한 닉네임입니다.');
        } else {
          toast.error('이미 사용중인 닉네임입니다.');
        }
        this.setState({
          isDupNicname: intReturn === 0 ? true : false,
          dupButtonNicnameSate: intReturn === 0 ? 'C' : 'B',
        });
      }
    }
  };
  _dupUseridApi = () => {
    const { apiUrl } = this.props;
    const { userid } = this.state;

    return axios
      .post(apiUrl + '/dupUserid', {
        params: {
          userid: userid,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _dupNicnameApi = () => {
    const { apiUrl } = this.props;
    const { nicName } = this.state;

    return axios
      .post(apiUrl + '/dupNicname', {
        params: {
          nicName: nicName,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _chkValue = (e) => {
    //console.log(e.target.name)
    //console.log(e.target.checked)
    if (e.target.name === 'aAgree') {
      this.setState({
        aAgree: e.target.checked,
        mAgree: e.target.checked,
        sAgree: e.target.checked,
        age14: e.target.checked,
      });
    }

    this.setState({
      [e.target.name]: e.target.checked,
    });
  };
  _goStep2 = () => {
    const {
      userid,
      nicName,
      password,
      password_re,
      mobile,
      email,
      mAgree,
      sAgree,
      isDupUsreid,
      isDupNicname,
      age14,
      parentAgree,
    } = this.state;

    if (userid === '' || userid === null || userid === undefined) {
      toast.warn('아아디를 입력해 주세요.');
      return;
    }
    if (isDupUsreid === false) {
      toast.warn('아이디 중복을 확인해 주세요.');
      return;
    }
    if (nicName === '' || nicName === null || nicName === undefined) {
      toast.warn('닉네임을  입력해 주세요.');
      return;
    }
    if (isDupNicname === false) {
      toast.warn('닉네임 중복을 확인해 주세요.');
      return;
    }
    if (password === '' || password === null || password === undefined) {
      toast.warn('비밀번호를 입력해 주세요.');
      return;
    }
    if (password.length > 20 || password.lenght < 4) {
      toast.warn('비밀번호는 4 ~ 20자리 문자, 숫자로 입력해 주세요.');
      return;
    }
    if (password !== password_re) {
      toast.warn('비밀번호가 일치하지 않습니다..');
      return;
    }
    if (/(\w)\1\1\1/.test(password)) {
      alert('비밀번호안에 같은문자는 4번 이상 사용할 수 없습니다.');
    }
    if (mobile === '' || mobile === null || mobile === undefined) {
      toast.warn('휴대폰 번호를 입력해 주세요.');
      return;
    }
    if (!/01[01689]-[1-9]{1}[0-9]{2,3}-[0-9]{4}$/.test(mobile)) {
      alert('휴대폰 번호 양식이 아닙니다.');
    }
    if (email === '' || email === null || email === undefined) {
      toast.warn('이메일을 입력해 주세요.');
      return;
    }
    if (
      !/^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i.test(
        email
      )
    ) {
      toast.warn('이메일 양식이 아닙니다.');
    }
    if (mAgree === false) {
      toast.warn('회원가입 약관에 동의해 주세요');
      return;
    }
    if (sAgree === false) {
      toast.warn('서비스 제공을 위한 개인정보 수집/이용 약관에 동의해 주세요.');
      return;
    }

    if (age14 === false) {
      if (parentAgree > 0) {
        this.setState({
          joinStep: 2,
        });
      } else {
        confirmAlert({
          title: '만 14세 미만인가요?',
          message:
            '만 14세 미만은 보호자(부모님)의 동의가 필요합니다. 법정 보호자로써 피보호자의 회원가입에 동의하십니까?',
          buttons: [
            {
              label: '아니오',
            },
            {
              label: '예 동의합니다.(법정보호인 휴대폰 인증)',
              onClick: () => {
                const popupUrl =
                  'https://www.aniplustv.com/aniplus2020Api/Join/parent_join_2nd_1.asp';
                window.open(
                  popupUrl,
                  'certWindow',
                  'width=450, height=600, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250'
                );
              },
            },
          ],
        });
      }
    } else {
      this.setState({
        joinStep: 2,
      });
    }
  };
  _onGoEvent = () => {
    const { backNumber } = this.state;
    const { history } = this.props;

    if (backNumber === 1) {
      //setEventIdx(279)
      window.open(
        'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=93&event_id=8',
        '',
        ''
      );
    } else {
      //window.open('https://shop.aniplustv.com/cafe/22', '', '')
      //setEventIdx(278)
      history.push('/tlist?ts=7');
    }
  };
  render() {
    const {
      userid,
      username,
      nicName,
      password,
      password_re,
      mobile,
      email,
      aAgree,
      mAgree,
      sAgree,
      isDupUsreid,
      isDupNicname,
      dupButtonState,
      dupButtonNicnameSate,
      joinStep,
      cert,
      age14,
      parentAgree,
    } = this.state;
    //console.log(email)
    return (
      <Fragment>
        <div className="login_container">
          <div className="login_logo">
            <Link to="/">
              <img src="img/login_img/login_logo.png" />
            </Link>
          </div>
          <div className="join_btn">
            <Link to="/login">로그인</Link>
          </div>
          {/* backNumber === 1 ? 
                       (<img src="https://file.aniplustv.com/aniplustv/event/aketo_20201126/btn.png" className="open_img" style={{cursor: 'pointer'}} onClick={this._onGoEvent}/>) 
                    : 
                       (<img src="https://file.aniplustv.com/aniplustv/event/titan_20201123/btn.png" className="open_img" style={{cursor: 'pointer'}} onClick={this._onGoEvent}/>) 
                    */}

          {joinStep === 1 ? (
            <JoinStep1
              userid={userid}
              nicName={nicName}
              password={password}
              password_re={password_re}
              mobile={mobile}
              email={email}
              aAgree={aAgree}
              mAgree={mAgree}
              sAgree={sAgree}
              age14={age14}
              parentAgree={parentAgree}
              isDupUsreid={isDupUsreid}
              isDupNicname={isDupNicname}
              cert={cert}
              dupButtonState={dupButtonState}
              dupButtonNicnameSate={dupButtonNicnameSate}
              dupUserid={this._dupUserid}
              dupNicname={this._dupNicname}
              chkValue={this._chkValue}
              onChange={this._onChange}
              onMobile={this._onMobile}
              onIpin={this._onIpin}
              goStep2={this._goStep2}
            />
          ) : joinStep === 2 ? (
            <JoinStep2 />
          ) : joinStep === 3 ? (
            <JoinStep3
              username={username}
              userid={userid}
              mobile={mobile}
              nicName={nicName}
              email={email}
            />
          ) : null}
        </div>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
        {/*
                <div>
                    <p>회원가입</p>
                    <p onClick={this._onMobile}>휴대폰 실명인증</p>
                    <p onClick={this._onIpin}>아이핀 실명인증</p>
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Join));
